import React, { useState, useEffect, useCallback } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button, Label, Input,
  Form,
  Spinner,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import {
  postRequest,
} from "../../components/Common/Utils.js";
import Chart from 'react-apexcharts';

import { Bar, Line } from 'react-chartjs-2';


const defaultChartData = {
  labels: [],
  datasets: [{
    label: 'User Registrations',
    data: [],
    backgroundColor: 'rgba(75, 192, 192, 0.2)',
    borderColor: 'rgba(75, 192, 192, 1)',
    borderWidth: 1,
    tension: 0.5,
    fill: false,
  }]
}

const options = {
  scales: {
    y: {
      beginAtZero: true,
    },
  },
};


export default function RevenueChartData() {
  // const [chartData, setChartData] = useState(defaultChartData);
  const [previewCover, setPreviewCover] = useState("");
  const [previewLogo, setPreviewLogo] = useState("");
  const [loading, setLoading] = useState(false);
  const [componentType, setComponentType] = useState("user");
  const [period, setPeriod] = useState("current-month");
  const [chartType, setChartType] = useState("bar");

  const [lastPeriod, setLastPeriod] = useState("current-month");

  const [showModel, setShowModel] = useState(false);

  const [inputData, setInputData] = useState({
    componentType: "user",
    period: "current-month",
    chartType: "bar",
    interval: "day",
    dateStart: "",
    dateEnd: "",
  })

  const [selectedLogo, setSelectedLogo] = useState("");
  const [selectedCover, setSelectedCover] = useState("");
  const [selectedLogourl, setSelectedLogourl] = useState("");
  const [selectedCoverurl, setSelectedCoverurl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const updateInput = (target, value) => {
    setInputData({
      ...inputData,
      [target]: value
    })

    if (value === 'custom-date') {
      setLastPeriod(inputData.period);
      setShowModel(true);
    }
  }

  // const closeModal = () => {
  //   setShowModel(false);
  //   updateInput('period', lastPeriod);
  // }

  // const selectDate = () => {
  //   setShowModel(false);
  //   console.log(inputData);
  // }

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: 'bar',
      },
      plotOptions: {
        bar: {
          columnWidth: '30%',
          borderRadius: 5,
        },
      },
      xaxis: {
        type: 'category',
        categories: [],
      },
      yaxis: {
        title: {
          text: 'Counts',
        },
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (y) {
            return typeof y !== 'undefined' ? `${y.toFixed(0)} ` : y;
          },
        },
      },
    },
  });


  useEffect(() => {
    fetchGraphList();
  }, []);

  useEffect(() => {
    fetchGraphList();
  }, [inputData]);

  const fetchGraphList = async () => {
    try {
      const res = await postRequest('analytics/revenue', inputData);
      if (res.status) {
        const categories = [
          { name: 'totalRevenue', type: 'column', title : 'Total Revenue' },
          { name: 'fmcgData', type: 'column', title : 'Informal Retailers'  },        
          { name: 'withoutfmcgData', type: 'column', title : 'SME'  },        
        ];

        const series = categories.map((category) => ({
          name: category.title.charAt(0).toUpperCase() + category.title.slice(1),
          type: category.type,
          data: res?.data?.find(item => item[category.name])?.[category.name].totals || []
        }));

        // Assuming labels are consistent across categories
        const labels = res.data[0]?.users?.labels || [];

        setChartData({
          series,
          options: {
            ...chartData.options,
            colors: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2'], // Custom colors for each series
            xaxis: {
              ...chartData.options.xaxis,
              categories: labels,
            },
          },
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };





  return (
    <React.Fragment>
      <ToastContainer />

      {/* header */}

      {/* form */}
      {/* <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <Form>
                
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row> */}

      <Row>
        <Col lg={12}>
          <Row className="align-items-center mb-3" style={{ justifyContent: 'end' }}>
            <Col md={8}>
             <h3>Revenue Overview</h3>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="period">Period</Label>
                <Input
                  type="select"
                  id="period"
                  value={inputData.period}
                  onChange={e => updateInput('period', e.target.value)}
                >
                  <option value="current-month">Current Month</option>
                  <option value="current-year">Current Year</option>
                  <option value="last-30-days">Last 30 Days</option>
                  <option value="last-12-month">Last 12 Months</option>
                  <option value="previous-month">Previous Month</option>
                  <option value="previous-year">Previous Year</option>
                  {/* <option value="custom-date">Custom Date</option> */}
                </Input>
              </FormGroup>
            </Col>

            <Col md={1}>
              <Button type="button" color="primary" style={{ marginTop: "24px" }} block>Submit</Button>
            </Col>
          </Row>
          {isLoading ? (<center><img className="text-center" src="https://c.tenor.com/I6kN-6X7nhAAAAAj/loading-buffering.gif" alt="Loading..." /></center>) : (
            <>
              <Chart
                options={chartData.options}
                series={chartData.series}
                type="line"
                height={350}
              />
            </>
          )}
        </Col>
      </Row >


    </React.Fragment >
  );
}
